var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 62,
    viewBox: "0 0 160 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2235_3063)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 148,
    height: 50,
    rx: 14,
    fill: "#3E5692",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2235_3063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.856 17V40.912H47.084V17H49.856ZM38.236 17.7C38.1987 21.4333 37.8813 24.7093 37.284 27.528L45.012 37.832L42.772 39.428L36.416 30.748C35.52 33.4173 34.3533 35.508 32.916 37.02C31.4787 38.532 29.8267 39.3533 27.96 39.484V36.684C29.5093 36.4413 30.844 35.452 31.964 33.716C33.084 31.9613 33.9333 29.684 34.512 26.884C35.0907 24.084 35.3893 20.9853 35.408 17.588L38.236 17.7ZM79.4776 24.7H76.1176V31.28H73.3456V17H76.1176V22.068H79.4776V24.7ZM62.7056 25.68C61.8656 27.0613 60.7643 28.1813 59.4016 29.04C58.0576 29.88 56.5269 30.3933 54.8096 30.58V28.06C56.7883 27.7613 58.3656 26.8933 59.5416 25.456C60.7363 24.0187 61.4083 22.1987 61.5576 19.996H55.1176V17.616H70.3776V19.996H64.3296C64.3109 21.0973 64.1149 22.2267 63.7416 23.384L71.0776 28.312L69.5936 30.384L62.7056 25.68ZM55.9016 32.596H76.1176V40.912H73.3176V35.004H55.9016V32.596ZM91.0952 20.78H97.4512V23.244H81.9392V20.78H88.2672V16.944H91.0952V20.78ZM106.411 29.348H103.051V40.912H100.279V17H103.051V26.688H106.411V29.348ZM89.6952 25.148C90.9832 25.148 92.1312 25.456 93.1392 26.072C94.1472 26.6693 94.9312 27.528 95.4912 28.648C96.0512 29.7493 96.3312 31.0187 96.3312 32.456C96.3312 33.8933 96.0512 35.172 95.4912 36.292C94.9312 37.3933 94.1472 38.2427 93.1392 38.84C92.1312 39.456 90.9832 39.764 89.6952 39.764C88.4072 39.764 87.2592 39.456 86.2512 38.84C85.2432 38.2427 84.4499 37.3933 83.8712 36.292C83.3112 35.172 83.0312 33.8933 83.0312 32.456C83.0312 31.0187 83.3112 29.7493 83.8712 28.648C84.4499 27.528 85.2432 26.6693 86.2512 26.072C87.2592 25.456 88.4072 25.148 89.6952 25.148ZM89.6952 37.356C90.4419 37.356 91.1139 37.16 91.7112 36.768C92.3085 36.376 92.7752 35.8067 93.1112 35.06C93.4659 34.3133 93.6432 33.4453 93.6432 32.456C93.6432 31.4667 93.4659 30.5987 93.1112 29.852C92.7752 29.1053 92.3085 28.536 91.7112 28.144C91.1139 27.752 90.4419 27.556 89.6952 27.556C88.5379 27.556 87.5859 28.004 86.8392 28.9C86.0925 29.7773 85.7192 30.9627 85.7192 32.456C85.7192 33.9493 86.0925 35.144 86.8392 36.04C87.5859 36.9173 88.5379 37.356 89.6952 37.356ZM127.885 17H130.657V40.912H127.885V17ZM109.461 36.796C111.607 36.796 113.465 36.264 115.033 35.2C116.619 34.1173 117.823 32.596 118.645 30.636C119.485 28.6573 119.905 26.3427 119.905 23.692V20.416H109.461V17.868H122.733V23.636C122.733 26.8093 122.191 29.5907 121.109 31.98C120.045 34.3507 118.505 36.1893 116.489 37.496C114.491 38.784 112.149 39.428 109.461 39.428V36.796Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2235_3063",
    x: 0,
    y: 0,
    width: 160,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.313851 0 0 0 0 0.313851 0 0 0 0 0.313851 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2235_3063"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2235_3063",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2235_3063",
    x: 21.96,
    y: 12.9438,
    width: 114.697,
    height: 35.9683,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.909804 0 0 0 0 0.909804 0 0 0 0 0.937255 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2235_3063"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2235_3063",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartBtn);
export default __webpack_public_path__ + "static/media/StartBtn.40a122528b0a3f0c680573fe83311b6a.svg";
export { ForwardRef as ReactComponent };